import { Component } from '@angular/core';
import { UtilsTabsComponent } from '../../components/utils-tabs/utils-tabs.component';

@Component({
  selector: 'app-orders',
  standalone: true,
  templateUrl: './orders.component.html',
  imports: [UtilsTabsComponent],
  styleUrl: './orders.component.scss'
})
export class OrdersComponent {}
